import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import API from '../../services/API';
import SyncMessage from "../../components/SyncMessage";

class AdkHourFactor extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            factors: {},
            syncData: null,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        API.AdkHourFactor.get().then(factors => this.setState({ factors }));
    }

    handleSave() {
        this.setState({ isLoading: true });

        API.AdkHourFactor.save(this.state.factors).then(() => this.setState({ isLoading: false }));
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'hourFactor')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    handleChange(event) {
        const { name, value:factor } = event.target;
        const [ day, hour ] = name.split('_');
        
        let { factors } = this.state;
        factors = Object.assign({}, factors);
        
        if(!factors[day]) factors[day] = {};

        factors[day][hour] = factor;

        this.setState({ factors });
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Day Factor"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleSave}>Save</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                <Table factors={this.state.factors} onChange={this.handleChange} />
            </Container>
        );
    }
}

export default AdkHourFactor;



// WEBPACK FOOTER //
// ./src/scenes/AdkHourFactor/index.js